export const REDUCER_NAME = 'Reporting'

export const actionTypes = {
  INITIALIZE: 'Reporting/INITIALIZE',
  STORE_UPDATES: 'Reporting/STORE_UPDATES',
  SET_PANEL_MODE: 'Reporting/SET_PANEL_MODE',
  FETCH_REPORTS: 'Reporting/FETCH_REPORTS',
  CHANGE_STATUS: 'Reporting/CHANGE_STATUS',
  CHECK_REPORTS_STATUS: 'Reporting/CHECK_REPORTS_STATUS',
  GENERATED_REPORTS_FETCHED: 'Reporting/GENERATED_REPORTS_FETCHED',
  CANCEL_CHECK: 'Reporting/CANCEL_CHECK',
  CLOSE: 'Reporting/CLOSE',
  GET_EXCEL_FILE: 'Reporting/GET_EXCEL_FILE',
}

export const panelModes = {
  folderSelected: 'folderSelected',
  itemSelectedWithDateRange: 'itemWithDateRange',
  itemSelectedWithoutDateRange: 'itemWithoutDateRange',
}
